// Mock data for AllePets listings and hosts
import listing1 from "@/assets/listing-1.jpg";
import listing2 from "@/assets/listing-2.jpg";
import listing3 from "@/assets/listing-3.jpg";
import listing4 from "@/assets/listing-4.jpg";

export interface Listing {
  id: string;
  title: string;
  hostName: string;
  location: string;
  neighborhood: string;
  rating: number;
  reviewCount: number;
  pricePerNight: number;
  pricePerDay: number;
  images: string[];
  features: string[];
  petTypes: string[];
  services: string[];
  description: string;
  hostDescription: string;
  routine: string;
  environment: string;
  included: string[];
  rules: string[];
  healthSafety: string[];
  isSuperhost: boolean;
}

export interface Review {
  id: string;
  author: string;
  rating: number;
  date: string;
  content: string;
  petName: string;
}

export const mockListings: Listing[] = [
  {
    id: "1",
    title: "Casa aconchegante com quintal amplo",
    hostName: "Maria Silva",
    location: "São Paulo, SP",
    neighborhood: "Pinheiros",
    rating: 4.9,
    reviewCount: 127,
    pricePerNight: 89,
    pricePerDay: 65,
    images: [listing1, listing2, listing3],
    features: ["quintal", "cameras", "24h", "medicacao"],
    petTypes: ["cao", "gato"],
    services: ["hospedagem", "creche"],
    description: "Espaço amplo e seguro para seu pet se sentir em casa. Quintal gramado com área sombreada.",
    hostDescription: "Amo animais desde criança. Tenho experiência de 5 anos cuidando de pets de todas as raças e portes.",
    routine: "Passeios pela manhã e tarde, alimentação nos horários indicados, muito carinho e atenção.",
    environment: "Casa espaçosa com quintal de 50m², gramado, área coberta e ar-condicionado.",
    included: ["Alimentação", "Passeios diários", "Fotos e vídeos", "Banho semanal"],
    rules: ["Vacinas em dia", "Vermifugado", "Sem comportamento agressivo"],
    healthSafety: ["Primeiros socorros", "Contato com veterinário 24h", "Seguro pet incluso"],
    isSuperhost: true,
  },
  {
    id: "2",
    title: "Apartamento pet-friendly no centro",
    hostName: "João Pedro",
    location: "São Paulo, SP",
    neighborhood: "Vila Madalena",
    rating: 4.8,
    reviewCount: 89,
    pricePerNight: 75,
    pricePerDay: 55,
    images: [listing2, listing1, listing4],
    features: ["cameras", "24h", "filhote"],
    petTypes: ["cao", "gato"],
    services: ["hospedagem", "creche", "petsitter"],
    description: "Apartamento espaçoso e adaptado para pets pequenos e médios.",
    hostDescription: "Veterinário por formação, cuido de pets com todo carinho e conhecimento técnico.",
    routine: "Rotina personalizada de acordo com as necessidades do seu pet.",
    environment: "Apartamento de 80m² com varanda telada e espaço dedicado para pets.",
    included: ["Alimentação premium", "Passeios", "Monitoramento por câmera"],
    rules: ["Vacinas em dia", "Castrado preferencial"],
    healthSafety: ["Veterinário no local", "Medicação se necessário"],
    isSuperhost: false,
  },
  {
    id: "3",
    title: "Sítio com muito espaço verde",
    hostName: "Ana Costa",
    location: "Cotia, SP",
    neighborhood: "Granja Viana",
    rating: 5.0,
    reviewCount: 56,
    pricePerNight: 120,
    pricePerDay: 90,
    images: [listing3, listing4, listing1],
    features: ["quintal", "cameras", "24h", "idoso", "medicacao"],
    petTypes: ["cao"],
    services: ["hospedagem"],
    description: "Sítio com 2000m² de área verde, perfeito para cães de grande porte.",
    hostDescription: "Apaixonada por cães grandes, tenho 3 labradores que adoram fazer novos amigos.",
    routine: "Muito espaço para correr, nadar no lago e brincar o dia todo.",
    environment: "Sítio com gramado, lago, área sombreada e canil climatizado.",
    included: ["Alimentação", "Natação", "Socialização", "Fotos diárias"],
    rules: ["Sociável com outros cães", "Vacinas em dia"],
    healthSafety: ["Área cercada", "Veterinário parceiro próximo"],
    isSuperhost: true,
  },
  {
    id: "4",
    title: "Creche diurna especializada",
    hostName: "Carlos Mendes",
    location: "São Paulo, SP",
    neighborhood: "Moema",
    rating: 4.7,
    reviewCount: 203,
    pricePerNight: 95,
    pricePerDay: 70,
    images: [listing4, listing2, listing3],
    features: ["cameras", "filhote", "idoso"],
    petTypes: ["cao", "gato"],
    services: ["creche", "petsitter"],
    description: "Creche profissional com atividades lúdicas e socialização supervisionada.",
    hostDescription: "Adestrador certificado com 10 anos de experiência em comportamento animal.",
    routine: "Atividades em grupo, descanso, brincadeiras educativas e muito carinho.",
    environment: "Espaço comercial adaptado com playground para pets.",
    included: ["Atividades", "Petiscos", "Relatório diário"],
    rules: ["Avaliação comportamental prévia", "Vacinas em dia"],
    healthSafety: ["Equipe treinada", "Câmeras 24h"],
    isSuperhost: false,
  },
  {
    id: "5",
    title: "Lar temporário com muito amor",
    hostName: "Fernanda Lima",
    location: "São Paulo, SP",
    neighborhood: "Perdizes",
    rating: 4.9,
    reviewCount: 78,
    pricePerNight: 80,
    pricePerDay: 60,
    images: [listing1, listing3, listing2],
    features: ["quintal", "24h", "medicacao", "sem-outros-pets"],
    petTypes: ["cao", "gato"],
    services: ["hospedagem", "petsitter"],
    description: "Atenção exclusiva para seu pet - sem outros animais no período.",
    hostDescription: "Dedico 100% da atenção ao seu pet durante a estadia.",
    routine: "Rotina totalmente personalizada conforme orientações do tutor.",
    environment: "Casa com quintal, ambiente calmo e silencioso.",
    included: ["Atenção exclusiva", "Alimentação", "Passeios", "Updates por WhatsApp"],
    rules: ["Vacinas em dia", "Ficha completa do pet"],
    healthSafety: ["Primeiros socorros", "Transporte emergencial"],
    isSuperhost: true,
  },
  {
    id: "6",
    title: "Hotel boutique para gatos",
    hostName: "Patricia Gomes",
    location: "São Paulo, SP",
    neighborhood: "Itaim Bibi",
    rating: 4.8,
    reviewCount: 145,
    pricePerNight: 85,
    pricePerDay: 65,
    images: [listing2, listing4, listing1],
    features: ["cameras", "24h", "idoso", "medicacao"],
    petTypes: ["gato"],
    services: ["hospedagem"],
    description: "Espaço exclusivo para felinos, com arranhadores, tocas e muito conforto.",
    hostDescription: "Especialista em comportamento felino, mãe de 4 gatos resgatados.",
    routine: "Ambiente tranquilo, brincadeiras, escovação e muito carinho.",
    environment: "Espaço vertical com prateleiras, tocas e janelas com tela.",
    included: ["Areia premium", "Alimentação", "Escovação diária"],
    rules: ["FIV/FeLV negativo", "Castrado", "Vacinas em dia"],
    healthSafety: ["Ambiente esterilizado", "Veterinário felino parceiro"],
    isSuperhost: true,
  },
];

export const mockReviews: Review[] = [
  {
    id: "1",
    author: "Camila Rocha",
    rating: 5,
    date: "Janeiro 2025",
    content: "Minha Luna ficou super feliz! A Maria mandou fotos e vídeos todos os dias. Voltou mais gordinha de tão bem tratada!",
    petName: "Luna",
  },
  {
    id: "2",
    author: "Roberto Santos",
    rating: 5,
    date: "Dezembro 2024",
    content: "Excelente! O Thor é um cachorro grande e encontrou o espaço perfeito. Recomendo demais!",
    petName: "Thor",
  },
  {
    id: "3",
    author: "Juliana Mendes",
    rating: 4,
    date: "Dezembro 2024",
    content: "Muito bom! A Mia ficou bem cuidada. Só achei o preço um pouco alto, mas vale pela qualidade.",
    petName: "Mia",
  },
  {
    id: "4",
    author: "André Costa",
    rating: 5,
    date: "Novembro 2024",
    content: "Incrível experiência! O Bob voltou super tranquilo e feliz. Com certeza voltaremos!",
    petName: "Bob",
  },
];

export const serviceCategories = [
  { id: "hospedagem", label: "Hospedagem", icon: "Home" },
  { id: "creche", label: "Creche", icon: "Sun" },
  { id: "petsitter", label: "Pet Sitter", icon: "Heart" },
  { id: "passeio", label: "Passeio", icon: "MapPin" },
  { id: "veterinario", label: "Veterinário", icon: "Stethoscope" },
] as const;

export const filterOptions = [
  { id: "filhote", label: "Aceita filhote" },
  { id: "idoso", label: "Aceita idoso" },
  { id: "sem-outros-pets", label: "Sem outros pets" },
  { id: "quintal", label: "Com quintal" },
  { id: "cameras", label: "Com câmeras" },
  { id: "24h", label: "24h com o pet" },
  { id: "medicacao", label: "Medicação" },
] as const;

export const sortOptions = [
  { id: "recommended", label: "Recomendados" },
  { id: "price-low", label: "Menor preço" },
  { id: "rating", label: "Melhor avaliados" },
  { id: "distance", label: "Mais próximos" },
] as const;

export const faqItems = [
  {
    question: "Como funciona a hospedagem de pets?",
    answer: "Você busca anfitriões verificados na sua região, conversa com eles para tirar dúvidas, e agenda a hospedagem. Seu pet fica em um lar de verdade, com atenção individual e carinho.",
  },
  {
    question: "A hospedagem é segura?",
    answer: "Sim! Todos os anfitriões passam por verificação de identidade e perfil. Além disso, oferecemos seguro veterinário durante toda a estadia.",
  },
  {
    question: "Posso visitar o local antes?",
    answer: "Claro! Recomendamos que você agende uma visita prévia para conhecer o ambiente e o anfitrião antes de confirmar a reserva.",
  },
  {
    question: "E se eu precisar cancelar?",
    answer: "Cada anfitrião define sua política de cancelamento. As opções são: flexível (reembolso total até 24h antes), moderada (50% até 7 dias antes) ou rígida (sem reembolso).",
  },
  {
    question: "Como funciona a creche diária?",
    answer: "Seu pet passa o dia com o anfitrião, socializando e brincando. Você leva pela manhã e busca no final do dia. Perfeito para quem trabalha fora!",
  },
  {
    question: "Os anfitriões podem dar medicação?",
    answer: "Sim, muitos anfitriões estão preparados para administrar medicação. Verifique o selo 'Medicação' no perfil e converse com o anfitrião sobre as necessidades do seu pet.",
  },
  {
    question: "Recebo notícias do meu pet durante a estadia?",
    answer: "Sim! Os anfitriões enviam fotos e vídeos diariamente pelo WhatsApp ou pelo nosso app. Você acompanha tudo em tempo real.",
  },
  {
    question: "E se meu pet tiver uma emergência?",
    answer: "Nossos anfitriões têm acesso a uma rede de veterinários parceiros 24h. Em caso de emergência, o pet é atendido imediatamente e você é notificado na hora.",
  },
  {
    question: "Posso hospedar mais de um pet?",
    answer: "Sim! Muitos anfitriões aceitam múltiplos pets da mesma família. O preço adicional varia de acordo com cada anfitrião.",
  },
  {
    question: "Como me torno um anfitrião?",
    answer: "É fácil! Basta criar seu perfil, adicionar fotos do ambiente, definir seus serviços e preços. Nossa equipe vai avaliar e aprovar seu cadastro.",
  },
];

// ===== Tipos do retorno REAL da API (/api/buscar-servicos) =====
export type ApiListing = {
  servico_id: number;

  tipo_servico: {
    id: number | null;
    nome: string | null;
    tipo_precificacao: string | null;
  };

  anfitriao: {
    id: number | null;
    nome: string | null;
    bio?: string | null;
    endereco?: string | null;
    cidade?: string | null;
  };

  imagens: string[];

  vagas: {
    limite_pets: number;
    vagas_disponiveis: number;
    label: string;
  };

  avaliacoes: {
    media: number;
    total: number;
    texto?: string | null;
  };

  preferencias: {
    aceita: string[];
    porte: string[];
    adicionais: string[];
  };

  cancelamento: {
    key: string;
    label: string;
    texto_curto: string;
  };

  preco_base: number;
  tempo_resposta?: string | null;

  flags?: any
};


